import { useEffect, useState } from 'react'

import { CART_STORAGE_KEY } from './types'
import { CART_UPDATED_EVENT } from './useDeviceCatalogCart'

function getItemCount(): number {
  try {
    const raw = localStorage.getItem(CART_STORAGE_KEY)
    if (!raw) return 0
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return 0
    return parsed.reduce((sum, item) => sum + (item.quantity ?? 1), 0)
  } catch {
    return 0
  }
}

/**
 * Returns the device catalog cart item count. Syncs with localStorage and
 * listens for CART_UPDATED_EVENT so the header badge updates when the cart changes.
 */
export function useDeviceCatalogCartItemCount(): number {
  const [count, setCount] = useState(getItemCount)

  useEffect(() => {
    const handler = () => setCount(getItemCount())
    window.addEventListener(CART_UPDATED_EVENT, handler)
    return () => window.removeEventListener(CART_UPDATED_EVENT, handler)
  }, [])

  return count
}
